import { AudiqMark, AudiqWordmark } from '@audiq/ui';
import type { Persona } from '@audiq/shared';

interface Props {
  persona: Persona;
  flowName?: string;
}

// Anteprima visiva della persona: come si presenterà il bot in chat.
export function PersonaPreviewCard({ persona, flowName }: Props) {
  const opening =
    persona.opening_message?.trim() ||
    `Ciao, sono ${persona.name}. Faccio un po' di domande prima della ${
      flowName?.toLowerCase().includes('visita') ? 'visita' : 'tua richiesta'
    }.`;

  return (
    <div
      className="rounded-md border p-5"
      style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
    >
      <div className="mb-3 mono" style={{ color: 'var(--mute)' }}>
        Anteprima persona
      </div>

      <div className="flex items-start gap-4">
        <AudiqMark size={56} state="idle" />
        <div className="flex-1">
          <div className="flex items-baseline gap-2">
            <AudiqWordmark size="sm" />
            <span className="text-sm" style={{ color: 'var(--mute)' }}>
              · {persona.role}
            </span>
          </div>
          <div
            className="mt-3 inline-block rounded-2xl px-4 py-2.5 text-[14.5px]"
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--line)',
              borderRadius: '16px 16px 16px 4px',
              maxWidth: '90%',
            }}
          >
            {opening}
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2 mono" style={{ color: 'var(--mute)' }}>
        <span>tono · {persona.tone}</span>
        <span>·</span>
        <span>formality · {persona.formality}</span>
        <span>·</span>
        <span>emoji · {persona.use_emoji}</span>
      </div>
    </div>
  );
}
